import React from 'react';
import { connect } from 'react-redux';
import reduxForm from 'redux-form/lib/reduxForm';
import Login from '../Login';
import {
  submitLogInForm,
  showCreateAccount,
  showRequestResetPassword,
} from '../../user';

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(submitLogInForm(data)),
  clickCreateAccount: () => dispatch(showCreateAccount('Create Account')),
  clickRequestResetPassword: () =>
    dispatch(showRequestResetPassword('Forgot Password')),
});

const mapStateToProps = ({}, { feedUrl }) => ({
  feedUrl,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'login',
  })(Login)
);
